import { useEffect, useState } from 'react';

interface UseDealerSearchScrollSyncProps {
  openDealerDetails: boolean;
  toggle: (value?: boolean) => void;
}

/**
 * Custom hook to sync dealer search visibility with scroll behavior.
 * When opening dealer search, it ensures the page scrolls to top first if scrolled down.
 */
const useDealerSearchScrollSync = ({
  openDealerDetails,
  toggle,
}: UseDealerSearchScrollSyncProps): void => {
  const [isScolled, setIsScrolled] = useState(false);
  useEffect(() => {
    if (openDealerDetails) {
      window.scrollTo({ top: 0, behavior: 'smooth' });
      setTimeout(() => {
        setIsScrolled(true);
      }, 200);
    } else setIsScrolled(false);
  }, [openDealerDetails, toggle]);

  useEffect(() => {
    if (isScolled) toggle(true);
  }, [isScolled]);
};

export default useDealerSearchScrollSync;
